<template>
	<v-container>
		<v-card class="shadowCard">
      <v-subheader>Resultado del TOEFL</v-subheader>
      <v-card-text>
	      <v-textarea
	      	v-model="mensaje"
	      	readonly
	      	v-if="verToefl"
	      	auto-grow
	      >
	      </v-textarea>
      </v-card-text>
    </v-card>
    
    <Alerta    v-if="respuestaAlerta" :parametros="parametros"/>
	  <Loader    v-if="cargar"          :loader="loader"/>
  </v-container>
</template>
<script>
	// Componentes
  import Alerta     from '@/components/alertas/Alerta.vue'
  import Loader     from '@/components/alertas/Loader.vue'
	import Avataaars  from 'vuejs-avataaars'
	import { mapActions, mapGetters } from 'vuex'
	// Dependencias
  const  base64 = require('base-64');


  export default {
  	props:[
			'perfil'
	  ],

  	components:{
  		Alerta,
  		Avataaars,
  	},

    data: () => ({
    	respuestaAlerta: false,
      loader: true,
      cargar: false,
			parametros:{
      	dialogError: false,
      	mensaje: '',
      	color: ''
     	},
     	url:'',
     	mensaje:'',

     	verToefl: false
    }),

    computed:{
    	...mapGetters( 'login', [ 'getUsuarioLMS', 'getDatosUsuarioLMS', 'getAvatar']),
    },

    created () {


    	const id_usuario = base64.encode( this.getUsuarioLMS.id )
      // Hacemos la petición
      this.$http.get('calificacion.toefl/' + id_usuario).then( response => {
        // Guardamos los grupos
        console.log( response.body )

        if( response.body.paso == 2){
        	this.mensaje = 'Hola, primeramente, recibe un cordial saludo de parte de la escuela. Este mensaje es para informarte que la calificación de tu examen final ha sido generada y el resultado afortunadamente fue SATISFACTORIO, este logro se verá reflejado en el certificado que te proporcionaremos por parte de la escuela. Estamos muy contentos y orgullosos de tu desempeño. En caso de tener alguna duda adicional favor de enviar un mensaje a través de esta plataforma y con mucho gusto te ayudaremos. Felicitaciones nuevamente.'
        }


        if( response.body.paso == 1){
        	this.mensaje = 'Hola, primeramente, recibe un cordial saludo de parte de la escuela. Este mensaje es para informarte que la calificación de tu examen final ha sido generada y el resultado fue INSATISFACTORIO, no te preocupes, este resultado se pudo generar debido a diferentes factores. El examen deberá ser tomado en línea nuevamente, para poder asegurar tu conocimiento. La fecha para retomar el examen te será informada a través de esta plataforma y estamos seguros que lograras obtener un resultado satisfactorio. En caso de tener alguna duda adicional favor de enviar un mensaje a través de esta plataforma y con mucho gusto te ayudaremos.'
        }

        this.verToefl = true
      }).catch( error =>{
        if( error.status == 400 || error.status == 500){
    			this.parametros.mensaje      = error.body.message
    			this.parametros.dialogError  = true 
    			this.parametros.color        = '#FF2C2C' 
    			this.respuestaAlerta         = true 
    		}
      }).finally(()=>{ this.cargar = false })
    },

    methods: {
    	...mapActions( 'login', [ 'grabarUsuario', 'grabarDatosUsuario', 'grabarAvatar' ]),
    },
  }
</script>